import { computed, ref } from "vue";
import { displayPagingRange as displayPagingRangeUtil } from "@/common/common";
import type { ListData, ListOptions } from "../types";
import { TABLE_HEADERS } from "../constants";

/**
 * 一覧テーブル表示に必要なデータ整形と列情報を提供する composable。
 *
 * @returns テーブル描画に利用する列定義と表示用データ
 */
export const useRegularDeliveryTable = () => {
  /**
   * 定期配送一覧 ヘッダー
   */
  const tableHeaders = TABLE_HEADERS;

  const listLoading = ref<boolean>(false);

  const listOptions = ref<ListOptions>({
    page: 1,
    itemsPerPage: 10,
    sortBy: [],
    sortDesc: [],
    groupBy: [],
    groupDesc: [],
    multiSort: false,
    mustSort: false,
  });

  // 定期配送一覧 データ
  const listDataArray = ref<ListData[]>([]);
  const deleteItem = ref<ListData | undefined | null>(null);

  // 定期配送一覧 絞込み後の全データ数
  const listDataTotalCount = ref<number>(0);

  // 定期配送一覧 ページ数
  const pageCount = computed(() =>
    Math.max(
      1,
      Math.ceil(listDataTotalCount.value / (listOptions.value.itemsPerPage || 1))
    )
  );

  //ページング範囲の表示
  const displayPagingRange = ref<string>("");

  // 選択されたチェックボックス
  const selectListCheckbox = ref<Array<Record<string, unknown>>>([]);
  const selectedListItems = computed<ListData[]>(() => {
    return selectListCheckbox.value
      .map((item) => {
        if (item === null || item === undefined) {
          return undefined;
        }
        if (typeof item === "string" || typeof item === "number") {
          return listDataArray.value.find(
            (row) => row.regular_delivery_no === String(item)
          );
        }

        const internalItem = (item as { internalItem?: { raw?: ListData; value?: unknown } })
          .internalItem;
        if (internalItem?.raw) {
          return internalItem.raw;
        }
        if (internalItem?.value !== undefined && internalItem?.value !== null) {
          return listDataArray.value.find(
            (row) => row.regular_delivery_no === String(internalItem.value)
          );
        }

        const raw = (item as { raw?: ListData }).raw;
        if (raw) {
          return raw;
        }

        const nestedItem = (item as { item?: ListData }).item;
        return nestedItem ?? (item as ListData);
      })
      .filter((item): item is ListData => item !== undefined && item !== null);
  });

  const getRowProps = (item: unknown) => {
    console.log(item);
    return {
      class: "bk_gray_1",
    };
  };

  /**
   * ページング表示文字列を更新する
   */
  const updateDisplayPagingRange = (): void => {
    displayPagingRange.value = displayPagingRangeUtil(
      listOptions.value.page - 1,
      listOptions.value.itemsPerPage,
      listDataTotalCount.value
    );
  };

  return {
    tableHeaders,
    listLoading,
    listOptions,
    listDataArray,
    deleteItem,
    listDataTotalCount,
    pageCount,
    displayPagingRange,
    selectListCheckbox,
    selectedListItems,
    getRowProps,
    updateDisplayPagingRange,
  };
};
